import { render, staticRenderFns } from "./Inventory2.vue?vue&type=template&id=ec9b31ee"
import script from "./Inventory2.vue?vue&type=script&lang=js"
export * from "./Inventory2.vue?vue&type=script&lang=js"
import style0 from "./Inventory2.vue?vue&type=style&index=0&id=ec9b31ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports